module.exports = __webpack_public_path__ + "static/img/storageConstruct.9eecf757.png";